import { InjectionToken, Provider } from "@angular/core";
import { TableDataService } from "../table-data.service";
import { TableDataApiConfig } from "../types/table-api-config";

// eslint-disable-next-line @tseslint/no-explicit-any
export const TABLE_DATA_CONFIG: InjectionToken<TableDataApiConfig<any>> = new InjectionToken<TableDataApiConfig<any>>("TABLE_DATA_CONFIG");
/**
 * Factory function to provide the {@link TableDataService | TableDataService} as well as the needed {@link TABLE_DATA_CONFIG | TABLE_DATA_CONFIG}-token
 */
export function provideTableDataService<T> (apiConfig: TableDataApiConfig<T>): Provider[] {
  return [
    {
      provide: TABLE_DATA_CONFIG,
      useValue: apiConfig
    },
    {
      provide: TableDataService<T>
    }
  ];
}
